import React from "react";
import { connect } from "react-redux";
import { Col, Row } from "react-bootstrap";
import PropTypes from "prop-types";

import Table from "../../../layout/table";
import ConditionalButton from "../../../layout/conditional-button";

import { format as formatDate } from "../../../utils/date";
import { deepEqual } from "../../../utils/object";
import { clocks as getClocks } from "../../../actions/client";

class Timecards extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            size: 10,
            search: "",
            order: "clockStarted",
            index: 0,
            direction: "DESC",
            data: [],
            pages: 0,
            sources: [],
        };
    }

    componentDidUpdate = (old) => {
        if (!deepEqual(old?.matters, this.props?.matters)) {
            this.fetchData();
        } else if (!deepEqual(old?.updated, this.props?.updated)) {
            this.fetchData();
        }
    }

    fetchData = async () => {
        setTimeout(async () => {
            const __data = await this.props.getClocks(this.props.uuid, this.state.page, this.state.size, this.state.order, this.state.direction, this.state.search);
            let __count = 0;

            if ((__data) && (__data.length || 0 > 0))
                __count = Math.ceil(Number(__data[0].count) / Number(this.state.size));

            this.setState({
                ...this.state,
                data: __data,
                pages: __count
            });
        }, 30);
    }

    get headers() {
        return [
            {
                header: "Date",
                sortable: true,
                source: "clockStarted",
                className: "text-muted text-small text-uppercase w-10",
                onRender: this.onDateLinkFormat
            },
            {
                header: "Matter",
                sortable: true,
                source: "Matter.description",
                className: "text-muted text-small text-uppercase w-10",
                onRender: this.onLinkFormat
            },
            {
                header: "Staff",
                sortable: true,
                source: "lastName",
                className: "text-muted text-small text-uppercase w-20",
                onFormat: this.onEmployeeFormat
            },
            {
                header: "Notes",
                sortable: true,
                source: "notes",
                className: "text-muted text-small text-uppercase w-30"
            },
            {
                header: "Time",
                sortable: true,
                source: "minutes",
                className: "text-muted text-small text-uppercase w-10",
                onFormat: this.onTimeFormat
            }
        ]
    }

    onItemClick = (e) => {
        if (this.props.onSelect) this.props.onSelect({
            uuid: e.target.attributes["uuid"].value,
            matterUuid: e.target.attributes["matter"].value,
            employeeUuid: e.target.attributes["employee"].value,
            clockStarted: e.target.attributes["started"].value,
            clockEnded: e.target.attributes["ended"].value,
            minutes: e.target.attributes["minutes"].value,
            notes: e.target.attributes["notes"].value    
        });
    }


    onDateLinkFormat = (e, row) => {
        return this.onLinkFormat(formatDate(e), row);
    }

    onLinkFormat = (e, row) => {
        return <a uuid={row.uuid.toString()}
            matter={row.matterUuid.toString()}
            employee={row.employeeUuid.toString()}
            started={row.clockStarted.toString()}
            ended={row.clockEnded.toString()}
            minutes={row.minutes.toString()}
            notes={row.notes.toString()}
            onClick={this.onItemClick}
            href="#"
            role="link">{e}</a>
    }

    onEmployeeFormat = (e, row) => {
        return `${row["Person.lastName"]}, ${row["Person.firstName"]} (${row["Employee.title"]})`;
    }

    onColumnClick = (e) => {
        const __array = this.headers;
        const __index = __array.findIndex((item) => {
            return item.header === e.header && item.source === e.source;
        });

        this.setState({
            ...this.state,
            index: __index,
            direction: this.state.index === __index && this.state.direction === "DESC" ? "ASC" : "DESC",
            order: __array[__index].source,
            page: 0
        }, this.fetchData);

    }

    onSearch = (e) => {
        this.setState({
            ...this.state,
            search: e
        }, this.fetchData);
    }

    onSize = (e) => {
        this.setState({
            ...this.state,
            page: 0,
            size: Number(e)
        }, this.fetchData);
    }

    onPageChange = (e) => {
        this.setState({
            ...this.state,
            page: Number(e)
        }, this.fetchData);
    }



    render() {
        return (
            <>
                <Col xs="12">
                    <Row>
                        <Col xs="6">
                            <h2 className="small-title">Billable Time</h2>
                        </Col>
                        {this.props.onCreate ? (
                            <Col xs="6" style={{ textAlign: "right" }}>
                                <ConditionalButton enabledVariant="outline-primary" display enabled onEnabledClick={this.props.onCreate} icon="plus">Create Time</ConditionalButton>
                            </Col>
                        ) : ``}
                    </Row>
                </Col>
                <Col xs="12">
                    <Table
                        headers={this.headers}
                        page={this.state.data}
                        sort={{ index: this.state.index, direction: this.state.direction }}
                        size={this.state.size}
                        index={this.state.page}
                        pages={this.state.pages}
                        onColumnClick={this.onColumnClick}
                        onPageChange={this.onPageChange}
                    />
                </Col>
            </>
        )
    }
}

Timecards.propTypes = {
    auth: PropTypes.object.isRequired,
    profile: PropTypes.object,
    items: PropTypes.array,
    updated: PropTypes.object
};

const mapStateToProps = (state) => {
    return ({
        auth: state.auth,
        profile: state.licensee.profile,
        updated: state.client.clock
    });
};

export default connect(mapStateToProps, { getClocks })(Timecards);